import React from "react";
import { level } from "@/interfaces/Workshop";
import { SectionContainerLight } from "../common/sections/SectionContainerLight";

const workshop_levels: level[] = [
  {
    number: "1.0",
    text: "Pengenalan\nSKKNI",
    icon: "/img/course/workshop/workshop-icon-1.png",
    subtitle: "Awali perjalanan",
  },
  {
    number: "2.0",
    text: "Pelatihan\nProfesional\nMateri Praktik\nIndustri",
    icon: "/img/course/workshop/workshop-icon-2.png",
    subtitle: "Fondasi Kuat",
  },
  {
    number: "3.0",
    text: "Uji Kompetensi\nAsesmen\nLSP BNSP",
    icon: "/img/course/workshop/workshop-icon-3.png",
    subtitle: "Dunia Praktis",
  },
  {
    number: "4.0",
    text: "Sertifikat Nasional\nKompetensi Diakui",
    icon: "/img/course/workshop/workshop-icon-4.png",
  },
];

const workshop_benefits: string[] = [
  "Pelatih berstandar BNSP dan bidang keahlian",
  "Sertifikat penyelesaian terverifikasi Kemnaker",
  "Pelatihan perusahaan sesuai standar industri kerja",
  "Materi terstruktur sesuai kebutuhan berbasis SKKNI ",
  "Networking dengan praktisi & peluang kerja lebih luas ",
  "Analisis kebutuhan pelatihan (TNA) untuk perusahaan",
  "Sertifikat Kompetensi BNSP yang diakui secara nasional",
  "Uji kompetensi dengan asesor resmi Lembaga Sertifikasi Profesi",
];

const HeroSection = () => {
  return (
    <SectionContainerLight
      id="bootcamp_hero"
      additionalClassName="mx-6 !py-0 my-6"
    >
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <img
          src="/img/course/ornaments/book.png"
          alt="book"
          className="absolute hidden md:block lg:top-[250px] lg:left-[500px] md:top-[250px] md:left-[260px] w-[100px] z-0"
        />
        <img
          src="/img/course/ornaments/cross.png"
          alt="cross"
          className="absolute hidden md:block lg:top-[120px] md:top-[100px] lg:right-[10px] md:right-[60px] w-[100px] z-0"
        />
        <img
          src="/img/course/ornaments/dots.png"
          alt="dots"
          className="absolute hidden md:block lg:top-[80px] lg:left-[680px]  md:top-[50px] md:left-[350px] w-[100px] z-0"
        />
        <img
          src="/img/course/ornaments/triangle.png"
          alt="triangle"
          className="absolute hidden md:block lg:bottom-[10px] lg:right-[480px] md:bottom-[-50px] md:right-[50px] w-[50px] z-0"
        />

        <div className="mr-2 hidden md:block absolute lg:top-[-50px] lg:right-6 md:top-[-80px] md:right-5 h-full w-[550px] pointer-events-none z-10">
          <img
            src="/img/course/workshop/workshop-landing-4.png"
            alt="Hero Person"
            className="h-full w-full object-contain"
          />
        </div>

        <div className="flex flex-col lg:flex-row lg:items-start gap-10">
          <div className="w-full lg:w-1/2 lg:pr-12 mt-8 lg:mt-12">
            <p className="text-teal-600 font-body text-xl sm:text-2xl font-medium mb-2 leading-relaxed md:whitespace-nowrap">
              Pelatihan Perusahaan dan Uji Kompetensi Sertifikasi BNSP
            </p>
            <h1 className="text-2xl md:text-[40px] font-body font-bold text-gray-900 mb-2 md:mb-4 leading-normal">
              <span className="block">From Corporate Training to</span>
              <span className="block">National Recognition</span>
            </h1>
            <p className="text-gray-900 font-semibold font-body text-base sm:text-lg mb-6 leading-normal">
              <span className="block mb-2">Jadilah Tenaga Ahli Kompeten, Terverifikasi dan Diakui Nasional</span>
            </p>

            <p className="text-gray-800 font-medium font-body text-sm sm:text-base -mt-2 mb-2">
              Benefit yang didapatkan
            </p>
            <ul className="space-y-2 text-gray-800 text-sm sm:text-base mb-6">
              {workshop_benefits.map((text, index) => (
                <li key={index} className="flex items-center gap-2 my-2 sm:my-0">
                  <span className="text-green-600 text-lg">✅</span>
                  <span className="font-medium font-body leading-tight text- md:text-base">
                    {text}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="-mt-2 -mb-6">
          <div className="grid grid-cols-2 gap-4 sm:hidden border-2 border-black rounded-xl p-3 bg-white">
            {workshop_levels.map((item, index) => (
              <div
                key={index}
                className="text-center flex flex-col items-center"
              >
                <img src={item.icon} alt={item.text} className="mb-1 w-6 h-6" />
                <p className="text-base font-bold text-blue-800">
                  {item.number}
                </p>
                <p className="text-xs text-gray-600 whitespace-pre-line mt-1">
                  {item.text}
                </p>
              </div>
            ))}
          </div>

          <div className="hidden sm:block mt-6">
            <div className="max-w-fit border-2 border-black rounded-xl p-4 mt-4 bg-white">
              <div className="flex flex-col md:flex-row md:items-start items-center">
                {workshop_levels.map((phase, index) => (
                  <div
                    key={index}
                    className="flex flex-col items-center md:flex-row md:items-start"
                  >
                    <div className="flex flex-col items-center md:items-start">
                      <img
                        src={phase.icon}
                        alt={phase.text}
                        width={48}
                        height={48}
                      />
                      <p className="font-bold text-blue-600 text-base md:text-sm mt-2">
                        {phase.number}
                      </p>
                      <p className="text-gray-800 text-base md:text-xs text-center md:text-justify leading-tight">
                        {phase.text.split("\n").map((line, i) => (
                          <React.Fragment key={i}>
                            {line}
                            <br />
                          </React.Fragment>
                        ))}
                      </p>
                    </div>

                    {phase.subtitle && index < workshop_levels.length - 1 && (
                      <div className="flex flex-col items-center justify-center mx-2 flex-shrink-0">
                        <p className="text-xs md:text-[10px] font-bold text-gray-600 text-center leading-tight mb-1">
                          {phase.subtitle.split(" ").map((word, i) => (
                            <span key={i}>
                              {word}
                              <br />
                            </span>
                          ))}
                        </p>
                        <svg
                          width="90"
                          height="24"
                          viewBox="0 0 100 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <line
                            x1="0"
                            y1="4"
                            x2="90"
                            y2="4"
                            stroke="#000"
                            strokeWidth="1.5"
                            strokeDasharray="2 2"
                          />
                          <path
                            d="M90 0 L94 4 L90 8"
                            stroke="#000"
                            strokeWidth="1.0"
                            fill="none"
                          />
                        </svg>
                      </div>
                    )}
                  </div>
                ))}

              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionContainerLight>
  );
};

export default HeroSection;
